import { api } from "./rtkApi";

export const eventsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEvents: build.query({
      query: ({ activites, authToken, offset, limit }) => {
        return {
          method: "GET",
          url: `/event/list?activites=${activites}&idinexplore=0&offset=${offset}&limit=${limit}`,
        };
      },
    }),
    getEvent: build.query({
      query: ({ slug }) => {
        return {
          method: "GET",
          url: `/event/get/${slug}`,
        };
      },
    }),
    getEventDates: build.query({
      query: ({ id }) => {
        return {
          method: "GET",
          url: `/event/dates/${id}`,
        };
      },
    }),
    getEventsDates: build.query({
      query: ({ ids }) => {
        return {
          method: "GET",
          url: `/event/dates-multiple?ids=${JSON.stringify(ids)}`,
        };
      },
    }),
    getEventDate: build.query({
      query: ({ id }) => {
        return {
          method: "GET",
          url: `/event/get-date/${id}`,
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const { useGetEventsQuery, useGetEventQuery, useGetEventDatesQuery, useGetEventDateQuery, useGetEventsDatesQuery } = eventsApi;
